import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "rightWrap"
};
const _hoisted_2 = {
  class: "titlebox"
};
const _hoisted_3 = {
  class: "contentwrap"
};
const _hoisted_4 = {
  class: "relative"
};
const _hoisted_5 = {
  class: "conline"
};
const _hoisted_6 = {
  class: "itembox"
};
const _hoisted_7 = {
  class: "relative"
};
const _hoisted_8 = {
  class: "bottombutton"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_uploadfile = _resolveComponent("uploadfile");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_RemoveFilled = _resolveComponent("RemoveFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled");
  const _component_el_form = _resolveComponent("el-form");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.isadd ? '新增类型' : '编辑类型'), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
    ref: "formdata",
    model: $props.form,
    "label-width": "80"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: $props.formlabel.title,
      prop: "title",
      rules: [{
        required: true,
        message: `请填写${$props.formlabel.title}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.form.title = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel[3],
      prop: "3"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $props.form[3],
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $props.form[3] = $event),
        placeholder: "请选择",
        onChange: $options.mapchange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.mapoptions, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      class: "hide",
      label: $props.formlabel.onlyid,
      prop: "onlyid"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.onlyid,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $props.form.onlyid = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.icon
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_uploadfile, {
        uploadList: $data.parentIcon,
        name: "icon",
        field: $props.formfield.icon,
        width: 72,
        height: 72,
        onFileList: _cache[3] || (_cache[3] = $event => $options.fileListHandle($event, 'icon'))
      }, null, 8, ["uploadList", "field"]), _createVNode(_component_el_button, {
        class: "materialbtn",
        onClick: _cache[4] || (_cache[4] = $event => $options.openSourceMaterial(3))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("素材库")])),
        _: 1
      })])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.sortId,
      prop: "sortId"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        modelValue: $props.form.sortId,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $props.form.sortId = $event),
        min: 0,
        "controls-position": "right"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: "是否多级",
      prop: "isMultilevel"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $props.form.isMultilevel,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $props.form.isMultilevel = $event),
        onChange: $options.multilvelChange
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    }), _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [[_vShow, $props.form.isMultilevel]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.form.children, (item, cindex) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "formchild mb12",
        key: cindex
      }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form_item, {
        label: `选项${cindex + 1}${$props.formlabel.title}`,
        prop: 'children.' + cindex + '.title',
        rules: [{
          required: true,
          message: `请填写选项${cindex + 1}名称`
        }]
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: item.title,
          "onUpdate:modelValue": $event => item.title = $event
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 2
      }, 1032, ["label", "prop", "rules"]), _createVNode(_component_el_form_item, {
        label: `选项${cindex + 1}${$props.formlabel.icon}`
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_uploadfile, {
          uploadList: item.icon,
          name: "rowicon",
          field: $props.formfield.icon,
          width: 72,
          height: 72,
          onFileList: $event => $options.fileListHandle($event, `rowicon${cindex}`)
        }, null, 8, ["uploadList", "field", "onFileList"]), _createVNode(_component_el_button, {
          class: "materialbtn",
          onClick: $event => $options.openSourceMaterial(3, item, cindex)
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("素材库")])),
          _: 2
        }, 1032, ["onClick"])])]),
        _: 2
      }, 1032, ["label"])]), _withDirectives(_createVNode(_component_el_icon, {
        onClick: $event => $options.deleteRow(cindex)
      }, {
        default: _withCtx(() => [_createVNode(_component_RemoveFilled)]),
        _: 2
      }, 1032, ["onClick"]), [[_vShow, cindex !== 0]]), _createVNode(_component_el_icon, {
        onClick: $event => $options.addRow(cindex)
      }, {
        default: _withCtx(() => [_createVNode(_component_CirclePlusFilled)]),
        _: 2
      }, 1032, ["onClick"])])), [[_vShow, $props.form.isMultilevel]]);
    }), 128))]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
    plain: "",
    onClick: _cache[7] || (_cache[7] = $event => $data.dialogVisible = false)
  }, {
    default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("取消")])),
    _: 1
  }), _createVNode(_component_el_button, {
    type: "primary",
    plain: "",
    onClick: $options.savetypeHandle
  }, {
    default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("确认")])),
    _: 1
  }, 8, ["onClick"])])], 512)), [[_vShow, $data.dialogVisible]]);
}